export const enum EVENT_ID {
    Unknown = 0,
    GenericInformation = 100,
    GenericError = 101,
    GenericSuccess = 102,
    OrderExpired = 104,
    OrderCancelled = 105,
    OrderPaid = 106,
    ThirdPartyCheckoutError = 107,
    PaymentsNoBinRouteFound = 2054,
    ThreedsFlowIncomplete = 2061,
    ThreedsValidationFailed = 2062,
    PaymentsPolicyDemoModeRuleViolation = 2118,
    SecurityValidateOtpInvalid = 3717,
    IssuingBankPreventedTransaction = 10001,
    InvalidMerchantNumber = 10003,
    StolenLostCard = 10004,
    IssuingBankRejectedTransaction = 10005,
    GeneralError = 10006,
    InvalidTransaction = 10012,
    InvalidAmount = 10013,
    InvalidCardNumber = 10014,
    InvalidIssuer = 10015,
    FormatError = 10030,
    LostCard = 10041,
    StolenCard = 10043,
    InsufficientFunds = 10051,
    ExpiredCard = 10054,
    IncorrectPIN = 10055,
    FunctionNotPermittedCardholder = 10057,
    FunctionNotPermittedTerminal = 10058,
    WithdrawalLimitExceeded = 10061,
    RestrictedCard = 10062,
    ActivityAccountLimitExceeded = 10065,
    CallIssuer = 10070,
    PinTriesExceeded = 10075,
    LifeCycle = 10079,
    InvalidNonExistentToAccount = 100076,
    SystemMalfunction = 10096,
    DeclineRecoveryGenericError = 10200,
    Policy = 10215,
    SoftDecline = 10301,
    LoyaltyBalanceOnlyCollectionAvailable = 100501,
    LoyaltySaleMissingSessionKey = 100524,
    LoyaltySessionCreationFailed = 100549,
    LoyaltySessionHostRejectionOrTimeout = 100427,
    DirectDebitProviderProxySaleValidationFailedInvalidIban = 100813,
    DirectDebitProviderProxySaleValidationFailedRequiredField = 100814,
    DirectDebitProviderProxySaleValidationFailedInvalidFieldLength = 100815,
    DirectDebitProviderProxySaleValidationFailedDuplicateTransactionId = 100816,
    DirectDebitProviderProxySaleFailedMerchantNotFound = 100817,
    DirectDebitProviderProxySaleFailedIbanNotSupported = 100818,
    BancontactQRCodeEPAResContextExpired = 103057,
    BancontactQRCodeTrfTransIdContextExpired = 103117,
    BancontactQRCodeErrorReceived = 103123,
    BancontactQRCodeInvalidCriticalData = 103134,
    BancontactQRCodeUnauthenticatedTransaction = 103135,
    BlikProcessTransactionResponseErrorResponseCode = 104304,
    BlikProcessTransactionWrongTicketCode = 104343,
    BancomatPayTransactionClosedWithNegativeResult = 106038,
    BancomatPayTransactionCancelledWithNegativeResult = 106040,
    BancomatPayTransactionClosedWithNegativeResultDueToUnreqisteredMobile = 106041,
    BancomatPayTransactionClosedWithNegativeResultDueToUnauthenticatedUser = 106042,
    BancomatPayTransactionClosedWithNegativeResultBackEndError = 106043,
    BancomatPayNumberActiveOnBankNotEnabledForEcommerce = 106044,
    BancomatPayTransactionClosedWithNegativeResultDueToRefusalOnApp = 106045,
    BancomatPayTransactionClosedWithNegativeResultDueToExpiredPaymentRequestFromBankDomain = 106046,
    BancomatPayPreauthTransactionClosedWithNegativeResult = 106047,
    BancomatPayPreauthTransactionCancelledDueToExpiry = 106048,
    BancomatPayPreauthTransactionCanceledByClicnt = 106049,
    BancomatPayPreauthTransactionClosedWithPositiveResutl = 106050,
    BancomatPayTransactionClosedWithNegativeResultNotActiveApp = 106051,
    BancomatPayTransactionClosedWithNegativeResultDueToExpiredPaymentRequestFromUser = 106057,
    BancomatPayTransactionClosedWithNegativeResultDueToUnknownReason = 106058
}

export const DECLINE_RECOVERY_EVENT_IDS: Array<EVENT_ID> = [
    EVENT_ID.InsufficientFunds,
    EVENT_ID.FunctionNotPermittedCardholder,
    EVENT_ID.DeclineRecoveryGenericError,
    EVENT_ID.IssuingBankRejectedTransaction,
    EVENT_ID.WithdrawalLimitExceeded,
    EVENT_ID.Policy,
    EVENT_ID.SystemMalfunction,
    EVENT_ID.LifeCycle,
    EVENT_ID.ThreedsValidationFailed,
    EVENT_ID.LoyaltySaleMissingSessionKey
];

export const DIRECT_DEBIT_FAILED_EVENT_IDS: Array<EVENT_ID> = [
    EVENT_ID.DirectDebitProviderProxySaleValidationFailedInvalidIban,
    EVENT_ID.DirectDebitProviderProxySaleValidationFailedRequiredField,
    EVENT_ID.DirectDebitProviderProxySaleValidationFailedInvalidFieldLength,
    EVENT_ID.DirectDebitProviderProxySaleValidationFailedDuplicateTransactionId,
    EVENT_ID.DirectDebitProviderProxySaleFailedMerchantNotFound,
    EVENT_ID.DirectDebitProviderProxySaleFailedIbanNotSupported
];

export const FAILURE_EVENT_IDS: Array<EVENT_ID> = [
    ...DECLINE_RECOVERY_EVENT_IDS,
    ...DIRECT_DEBIT_FAILED_EVENT_IDS,
    EVENT_ID.PaymentsNoBinRouteFound,
    EVENT_ID.PaymentsPolicyDemoModeRuleViolation
];

export const BANCONTACT_EXPIRED_EVENT_IDS: Array<EVENT_ID> = [
    EVENT_ID.BancontactQRCodeEPAResContextExpired,
    EVENT_ID.BancontactQRCodeTrfTransIdContextExpired
];

export const BANCONTACT_FAILED_EVENT_IDS: Array<EVENT_ID> = [
    EVENT_ID.BancontactQRCodeErrorReceived,
    EVENT_ID.BancontactQRCodeInvalidCriticalData,
    EVENT_ID.BancontactQRCodeUnauthenticatedTransaction
];

export const BANCOMAT_PAY_FAILED_EVENT_IDS: Array<EVENT_ID> = [
    EVENT_ID.BancomatPayTransactionClosedWithNegativeResult,
    EVENT_ID.BancomatPayTransactionCancelledWithNegativeResult,
    EVENT_ID.BancomatPayTransactionClosedWithNegativeResultDueToUnreqisteredMobile,
    EVENT_ID.BancomatPayTransactionClosedWithNegativeResultDueToUnauthenticatedUser,
    EVENT_ID.BancomatPayTransactionClosedWithNegativeResultBackEndError,
    EVENT_ID.BancomatPayNumberActiveOnBankNotEnabledForEcommerce,
    EVENT_ID.BancomatPayTransactionClosedWithNegativeResultDueToRefusalOnApp,
    EVENT_ID.BancomatPayTransactionClosedWithNegativeResultDueToExpiredPaymentRequestFromBankDomain,
    EVENT_ID.BancomatPayTransactionClosedWithNegativeResultDueToExpiredPaymentRequestFromUser,
    EVENT_ID.BancomatPayTransactionClosedWithNegativeResultDueToUnknownReason,
    EVENT_ID.BancomatPayPreauthTransactionClosedWithNegativeResult,
    EVENT_ID.BancomatPayPreauthTransactionCancelledDueToExpiry,
    EVENT_ID.BancomatPayPreauthTransactionCanceledByClicnt,
    EVENT_ID.BancomatPayPreauthTransactionClosedWithPositiveResutl,
    EVENT_ID.BancomatPayTransactionClosedWithNegativeResultNotActiveApp
];

export const BLIK_FAILED_EVENT_IDS: Array<EVENT_ID> = [
    EVENT_ID.BlikProcessTransactionResponseErrorResponseCode,
    EVENT_ID.BlikProcessTransactionWrongTicketCode
];
